import { NearbyLocationsComponent } from './NearbyLocationsComponent';

export function NearbyLocationsComponentC(
  props: React.ComponentProps<typeof NearbyLocationsComponent>,
) {
  return <NearbyLocationsComponent {...props} />;
}
